import callAPI from '../../../../../API/callSecureAPI'
import endpoints from '../../../../../API/endpoints'
import { useAuth0 } from '../../../../../contexts/auth0-context'
import { useMutation } from 'react-query'
import { getTppCellsQueryKey } from '../../../../../components/TppView/hooks/useTppData'
import { useState } from 'react'
import { useQueryClient } from 'react-query'
import { TppCell } from '../../../../../components/TppView/types'
import { useInvalidateTPPChangeLogQuery } from '../../../../../components/TPPChangeLog/queries/useInvalidateTPPChangeLogQuery'

type ToggleTPPCellHighlightPayload = {
    cellId: string
    tppId: string
    highlight: boolean
}

type UseToggleTPPCellHighlightMutationProps = {
    onSuccess?: () => void
}

export const useToggleTPPCellHighlightMutation = ({ onSuccess }: UseToggleTPPCellHighlightMutationProps = {}) => {
    const [controller, setController] = useState<AbortController | null>(null)
    const { getTokenSilently } = useAuth0()

    const queryClient = useQueryClient()
    const { invalidateTPPChangeLogQuery } = useInvalidateTPPChangeLogQuery()

    const toggleTPPCellHighlight = async ({ cellId, tppId, highlight }: ToggleTPPCellHighlightPayload) => {
        console.log('Toggling highlight for cellId:', cellId, 'to', highlight)
        try {
            if (controller) {
                controller.abort()
                setController(null)
            }

            const abortController = new AbortController()
            setController(abortController)

            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.toggleHighlightTPPCell

            const response = await callAPI(
                `${url}/${cellId}/highlight`,
                method,
                token,
                { cellId, isHighlighted: highlight },
                { signal: abortController.signal }
            )

            return response.data
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    //const { invalidateGetTPPCellQuery } = useInvalidateGetTPPCellQuery()

    return useMutation(toggleTPPCellHighlight, {
        onSuccess: async (data, variables) => {
            const updatedCell = data?.data ?? data
            if (updatedCell) {
                queryClient.setQueryData<TppCell[]>(getTppCellsQueryKey(variables.tppId), (old) => {
                    if (!old) return []
                    return old.map((c) => (c._id === updatedCell._id ? { ...c, ...updatedCell } : c))
                })
            }

            invalidateTPPChangeLogQuery(variables.tppId)
            // still let the caller do extra stuff if they passed a callback
            onSuccess?.()
        },
    })
}
